import { Component, Vue } from 'vue-property-decorator';
import moment from 'moment';

@Component
export default class BillboardMixin extends Vue {
    createDateObject(value) {
        try {
            let parts = value.split('/');
            return moment(`${parts[2]}-${parts[1]}-${parts[0]}`).toDate();
        } catch (error) {
            return null;
        }
    }
};